import { render, staticRenderFns } from "./EmployeeFingerFormAdd.vue?vue&type=template&id=06f03d4d"
import script from "./EmployeeFingerFormAdd.vue?vue&type=script&lang=js"
export * from "./EmployeeFingerFormAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports